import { InvoiceSplitRuleType } from "@sp-crm/core";
import { percentStringToBasisPoints } from "./rate-percent";

export interface SplitRuleDraft {
    type: InvoiceSplitRuleType;
    recipientTerritoryId: string;
    ratePercent: string;
    enabled: boolean;
    notes: string;
}

export interface SplitAllocation {
    label: string;
    percent: number;
    cents: number;
}

export interface SplitDistribution {
    allocations: SplitAllocation[];
    officePercent: number;
    officeCents: number;
    totalSplitPercent: number;
    overAllocated: boolean;
}

export const totalSplitRuleBasisPoints = (rules: SplitRuleDraft[]): number =>
    rules
        .filter(rule => rule.enabled && rule.recipientTerritoryId !== "")
        .reduce((sum, rule) => sum + percentStringToBasisPoints(rule.ratePercent), 0);

export const totalSplitRulePercent = (rules: SplitRuleDraft[]): number =>
    totalSplitRuleBasisPoints(rules) / 100;

export const computeSplitDistribution = (
    rules: SplitRuleDraft[],
    totalCents: number,
    labelByTerritoryId: Map<string, string>,
): SplitDistribution => {
    const allocations = rules
        .filter(rule => rule.enabled && rule.recipientTerritoryId !== "")
        .map(rule => {
            const percent = parseFloat(rule.ratePercent || "0") || 0;
            return {
                label:
                    labelByTerritoryId.get(rule.recipientTerritoryId) ??
                    "Unknown recipient",
                percent,
                cents: Math.round((totalCents * percent) / 100),
            };
        });

    const totalSplitBasisPoints = totalSplitRuleBasisPoints(rules);
    const totalSplitPercent = totalSplitBasisPoints / 100;
    const allocatedCents = allocations.reduce((sum, a) => sum + a.cents, 0);

    return {
        allocations,
        officePercent: 100 - totalSplitPercent,
        officeCents: totalCents - allocatedCents,
        totalSplitPercent,
        overAllocated: totalSplitBasisPoints > 10000,
    };
};
